window.FullioArrivalProductPicker = (() => {
    let current = null;

    const dispose = () => {
        if (!current) return;
        current.controller?.abort();
        clearTimeout(current.timer);
        current = null;
    };

    const mount = (modal) => {
        dispose();
        const form = modal.contentEl.querySelector('[data-arrival-product-picker]');
        if (!form) return;
        const search = form.querySelector('[data-product-search]');
        const rows = form.querySelector('[data-product-rows]');
        const table = form.querySelector('[data-product-table]');
        const loading = form.querySelector('[data-product-loading]');
        const empty = form.querySelector('[data-product-empty]');
        const errors = form.querySelector('[data-product-error]');
        const more = form.querySelector('[data-product-more]');
        const submit = form.querySelector('[data-product-submit]');
        const state = {form, saving: false, loading: false, failed: false, controller: null, timer: null, sequence: 0, offset: 0, hasMore: false, retryAppend: false, selected: form.dataset.selectedProduct, ids: new Set()};
        current = state;
        const active = () => current === state && form.isConnected;
        const update = () => {
            submit.disabled = state.saving || state.loading || state.failed || !rows.querySelector('input:checked');
            more.disabled = state.loading || state.saving;
            more.classList.toggle('d-none', !state.hasMore);
            loading.classList.toggle('d-none', !state.loading);
        };
        const showError = (message) => {
            state.failed = true;
            form.querySelector('[data-product-error-message]').textContent = message;
            errors.classList.remove('d-none');
        };
        const select = (radio) => {
            radio.checked = true;
            state.selected = radio.value;
            rows.querySelectorAll('tr').forEach(row => row.classList.toggle('table-primary', row.contains(radio)));
            update();
        };
        const append = (product) => {
            if (state.ids.has(product.id)) return;
            state.ids.add(product.id);
            const row = document.createElement('tr');
            const choice = document.createElement('td');
            const radio = document.createElement('input');
            radio.type = 'radio';
            radio.className = 'form-check-input';
            radio.name = form.dataset.productName;
            radio.value = String(product.id);
            radio.title = `Выбрать ${product.code}`;
            radio.checked = state.selected === radio.value;
            choice.appendChild(radio);
            row.appendChild(choice);
            [product.code, product.sku, product.name].forEach((value, index) => {
                const cell = document.createElement('td');
                cell.textContent = value;
                if (index < 2) cell.className = 'font-monospace';
                if (index === 0) cell.classList.add('text-nowrap');
                row.appendChild(cell);
            });
            const barcodes = document.createElement('td');
            barcodes.className = 'font-monospace';
            product.barcodes.forEach(value => {
                const barcode = document.createElement('div');
                barcode.textContent = value;
                barcodes.appendChild(barcode);
            });
            row.appendChild(barcodes);
            row.classList.toggle('table-primary', radio.checked);
            row.addEventListener('click', () => { if (!state.loading && !state.saving && !state.failed) select(radio); });
            radio.addEventListener('change', () => select(radio));
            rows.appendChild(row);
        };
        const load = async (appendResults = false) => {
            if (!active() || state.saving) return;
            clearTimeout(state.timer);
            state.controller?.abort();
            const sequence = ++state.sequence;
            state.controller = new AbortController();
            state.loading = true;
            state.retryAppend = appendResults;
            state.failed = false;
            errors.classList.add('d-none');
            if (!appendResults) {
                rows.replaceChildren();
                state.ids.clear();
                state.offset = 0;
                state.hasMore = false;
                table.classList.add('d-none');
                empty.classList.add('d-none');
            }
            update();
            const url = new URL(form.action, location.href);
            url.searchParams.set('products', '1');
            url.searchParams.set('search', search.value);
            url.searchParams.set('offset', String(state.offset));
            try {
                const response = await fetch(url, {signal: state.controller.signal, headers: {'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json'}, redirect: 'error'});
                if (!response.ok) throw new Error('Search failed');
                const payload = await response.json();
                if (!active() || sequence !== state.sequence) return;
                if (payload.result !== 'arrival-product-search' || !Array.isArray(payload.products) || payload.products.length > 50 || typeof payload.has_more !== 'boolean' || !Number.isInteger(payload.next_offset) || (payload.has_more && payload.next_offset <= state.offset) || !payload.products.every(product => Number.isInteger(product.id) && product.id > 0 && ['code', 'sku', 'name'].every(key => typeof product[key] === 'string') && Array.isArray(product.barcodes) && product.barcodes.every(value => typeof value === 'string'))) throw new Error('Invalid search result');
                payload.products.forEach(append);
                state.offset = payload.next_offset;
                state.hasMore = payload.has_more;
                table.classList.toggle('d-none', rows.children.length === 0);
                empty.classList.toggle('d-none', rows.children.length !== 0);
            } catch (error) {
                if (!active() || sequence !== state.sequence || error.name === 'AbortError') return;
                showError('Не удалось загрузить товары. Проверьте соединение и повторите поиск.');
            } finally {
                if (active() && sequence === state.sequence) {
                    state.loading = false;
                    update();
                }
            }
        };
        search.addEventListener('input', () => {
            state.controller?.abort();
            ++state.sequence;
            clearTimeout(state.timer);
            state.selected = '';
            rows.replaceChildren();
            table.classList.add('d-none');
            empty.classList.add('d-none');
            errors.classList.add('d-none');
            state.hasMore = false;
            state.loading = true;
            update();
            state.timer = setTimeout(() => load(), 250);
        });
        search.addEventListener('keydown', event => {
            if (event.key !== 'Enter') return;
            event.preventDefault();
            if (!state.saving) load();
        });
        more.addEventListener('click', () => load(true));
        form.querySelector('[data-product-retry]').addEventListener('click', () => load(state.retryAppend));
        state.submit = async (event) => {
            if (event.submitter !== submit || submit.disabled || !form.reportValidity()) return;
            const data = new FormData(form);
            if (submit.name) data.append(submit.name, submit.value);
            state.saving = true;
            state.retryAppend = false;
            state.failed = false;
            errors.classList.add('d-none');
            const controls = Array.from(form.querySelectorAll('input, button'));
            const disabled = controls.map(control => control.disabled);
            controls.forEach(control => { control.disabled = true; });
            try {
                const response = await fetch(form.action, {method: 'POST', body: data, headers: {'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json'}, redirect: 'error'});
                if (!response.ok) throw new Error('Save failed');
                const payload = await response.json();
                if (!active()) return;
                if (!['html', 'refresh', 'redirect'].includes(payload.result)
                    || typeof modal.events[payload.result] !== 'function'
                    || (payload.result === 'html' && typeof payload.html !== 'string')
                    || (payload.result === 'redirect' && typeof payload.url !== 'string')) {
                    throw new Error('Invalid save result');
                }
                modal.events[payload.result](payload);
            } catch (error) {
                if (active()) showError('Не удалось получить результат добавления товара. Введённые данные сохранены. Проверьте соединение и состав приёмки перед повторной попыткой.');
            } finally {
                state.saving = false;
                controls.forEach((control, index) => { control.disabled = disabled[index]; });
                if (active()) update();
            }
        };
        load();
        search.focus();
    };

    return {mount, dispose, isSaving: () => current?.saving === true, submit: (event) => current?.submit(event)};
})();
